import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import getFetchDesignViewsOptions from './get-options';
var useFetchDesignViews = function useFetchDesignViews(_ref) {
  var designViewId = _ref.designViewId,
    select = _ref.select;
  return useQuery(_objectSpread(_objectSpread({
    enabled: Boolean(designViewId)
  }, getFetchDesignViewsOptions({
    designViewId: designViewId
  })), select && {
    select: select
  }));
};
export default useFetchDesignViews;